/// <amd-module name="Wit/WorkItemForm/Attachments/AttachmentActions" />
import { ILinkInfo } from "Wit/WorkItemDataManager/Contracts";

/**
 * Provides the actions that can be performed on any attachment.
 */
export interface IAttachmentActions {
    onEditComment?: (attachment: ILinkInfo) => void;
    onDownloadAttachment: (attachment: ILinkInfo) => void;
    onDeleteAttachment?: (attachment: ILinkInfo) => void;
    onPreviewAttachment: (attachment: ILinkInfo) => void;
    onCopyAttachmentUrl: (attachment: ILinkInfo) => void;
}

/**
 * Provides the actions that can be performed on a particular attachment.
 * The caller does not need a reference to the actual attachment.
 */
export type ICurriedAttachmentActions = {
    [K in keyof IAttachmentActions]: () => void;
};

/**
 * Curries all of the functions on the `actions` with the provided attachment as the argument.
 * This enables us to avoid passing passing the attachment around in contexts where there
 * is only one attachment to deal with.
 *
 * @param attachment The attachment on which to perform the actions
 * @param actions The actions to peroform
 */
export function curryAttachmentActions(attachment: ILinkInfo, actions: IAttachmentActions): ICurriedAttachmentActions {
    const triggers = {} as ICurriedAttachmentActions;
    for (const key of Object.keys(actions) as (keyof ICurriedAttachmentActions)[]) {
        if (actions[key]) {
            triggers[key] = () => actions[key]!(attachment);
        }
        
    }
    return triggers;
}
